{
  "version": 1,
  "asset_id": "e61d68d1-a05c-4e48-a40b-3af17cb65ecc",
  "project_id": "115256dd-a6cc-4bc1-95c1-d787d4c0e481",
  "url": "/__l5e/assets-v1/e61d68d1-a05c-4e48-a40b-3af17cb65ecc/cleaning-hero.webp",
  "r2_key": "a/v1/115256dd-a6cc-4bc1-95c1-d787d4c0e481/e61d68d1-a05c-4e48-a40b-3af17cb65ecc/cleaning-hero.webp",
  "original_filename": "cleaning-hero.webp",
  "size": 76662,
  "content_type": "image/webp",
  "created_at": "2026-07-28T02:24:58Z"
}
